/* __next_internal_client_entry_do_not_use__ SaveToBoardContext,SaveToBoardProvider auto */ import { createContext } from "react";
export var SaveToBoardContext = createContext({});
export var SaveToBoardProvider = SaveToBoardContext.Provider;
